"use client";

type Heading = {
  id: string;
  text: string;
  level: number;
};

type Props = {
  headings: Heading[];
};

export function TableOfContents({ headings }: Props) {
  if (!headings.length) return null;

  return (
    <nav
      className="rounded-3xl border border-border bg-surface/80 p-4 text-sm text-text-secondary dark:text-offwhite/70"
      aria-label="Table of contents"
    >
      <p className="text-xs uppercase tracking-[0.3em] text-emerald">On this page</p>
      <ul className="mt-3 space-y-2">
        {headings.map((heading) => (
          <li key={heading.id} className="text-sm">
            <a href={`#${heading.id}`} className="transition hover:text-emerald dark:hover:text-emerald">
              {heading.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
